module.exports = require('./dist/cleave-react-node.js');



/*****************
 ** WEBPACK FOOTER
 ** ./~/cleave.js/react.js
 ** module id = 1236
 ** module chunks = 0
 **/